"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.isEdgeRuntime = exports.isBrowser = exports.isWebWorker = exports.isNetlify = exports.isVercel = exports.Version = void 0;
const generic_1 = __importDefault(require("./platform/generic"));
const vercel_1 = __importDefault(require("./platform/vercel"));
const netlify_1 = __importDefault(require("./platform/netlify"));
exports.Version = require('../package.json').version;
exports.isVercel = process.env.NEXT_PUBLIC_AXIOM_INGEST_ENDPOINT || process.env.AXIOM_INGEST_ENDPOINT;
exports.isNetlify = process.env.NETLIFY == 'true';
exports.isWebWorker = typeof self !== 'undefined' &&
    typeof globalThis.WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope;
exports.isBrowser = typeof window !== 'undefined' || exports.isWebWorker;
exports.isEdgeRuntime = globalThis.EdgeRuntime ? true : false;
// Detect the platform provider, and return the appropriate config
// fallback to generic config if no provider is detected
let config = new generic_1.default();
exports.config = config;
if (exports.isVercel) {
    exports.config = config = new vercel_1.default();
}
else if (exports.isNetlify) {
    exports.config = config = new netlify_1.default();
}
//# sourceMappingURL=config.js.map